import { Data } from '@blade/std-lib'

import type { CurrencyModel } from '@root/entities/currency'
import type BigNumber from 'bignumber.js'

export class InsufficientBalanceError extends Data.TaggedError(
  'InsufficientBalance',
)<{
  amount: BigNumber
  balance: BigNumber
  currency?: CurrencyModel
}> {}

export class InsufficientBalanceLightError extends Data.TaggedError(
  'InsufficientBalance',
) {}

export class NoAmountError extends Data.TaggedError('NoAmount') {}
